export const SITE_NAME = 'Muita Mídia'
export const SITE_LEGAL_NAME = 'Muita Mídia LTDA'
export const SITE_CNPJ = '51.781.940/0001-04'
export const SITE_URL = 'https://muitamidia.com.br'
export const SITE_EMAIL = 'contato@muitamidia.com.br'
export const WHATSAPP_NUMBER = '5531983316620'
export const WHATSAPP_DISPLAY = '(31) 98331-6620'
export const INSTAGRAM_URL = 'https://www.instagram.com/muitamidiaofc'
export const TELEGRAM_URL = 'https://t.me/comprarcontainstagram'

export const ADDRESS = {
  street: 'Avenida Afonso Pena, 3355, Sala 1101',
  neighborhood: 'Serra',
  city: 'Belo Horizonte',
  state: 'MG',
  postalCode: '30130-008',
  country: 'BR',
}

export const ADDRESS_LINE = `${ADDRESS.street}, ${ADDRESS.neighborhood}, ${ADDRESS.city}/${ADDRESS.state}, CEP ${ADDRESS.postalCode}`

export const MAP_EMBED_SRC =
  'https://maps.google.com/maps?q=Avenida%20Afonso%20Pena%203355%20Sala%201101%20Serra%20Belo%20Horizonte%20MG&t=&z=16&ie=UTF8&iwloc=&output=embed'

export const DEFAULT_TITLE = 'Comprar Perfil Instagram | Muita Mídia — Desde 2019'
export const DEFAULT_DESCRIPTION =
  'Compre perfis nichados do Instagram com seguidores reais. +8.400 perfis vendidos e +7.000 clientes desde 2019. Atendimento via WhatsApp.'

export const HERO_IMAGE =
  'https://static.lumi.new/09/0978b469cfb34bfcb7b342a59fe9077d.png'
export const OFFICE_IMAGE =
  'https://static.lumi.new/2c/2c104aaf9bbeca6da210de25c20d5d6e.png'
export const ANALYTICS_IMAGE =
  'https://static.lumi.new/2d/2d1092b65d9898b2a22e8da44e4671ba.png'
export const TEAM_IMAGES = {
  commercial: 'https://static.lumi.new/d5/d5b2b3fb975b37e84b382cb1c56c4d86.png',
  curation: 'https://static.lumi.new/1d/1d01cc3f92ffa43fd0a6c859c28d318b.png',
  support: 'https://static.lumi.new/0c/0c12f860f87a6118a47f883a2035e561.png',
}
export const BLOG_IMAGES = {
  seguranca: 'https://static.lumi.new/a6/a6ee55c782016bfd998c83ac493e750d.png',
  valor: 'https://static.lumi.new/d8/d8a767d7ac995b5a3b232ea64146880e.png',
  nichos: 'https://static.lumi.new/09/097a0dbfefd6ccfb8a8603b7320af8e6.png',
  transferencia: 'https://static.lumi.new/ce/ce0947e24854275a34eb5b177b3e0c0e.png',
  seguidores: 'https://static.lumi.new/40/404259fb113c5179fce95a41ad149110.png',
}

export function waLink(message: string) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}

export const WA_DEFAULT = waLink(
  'Olá, Muita Mídia. Quero comprar um perfil no Instagram com seguidores reais. Podem me atender?',
)

export const WA_CATALOG = waLink(
  'Olá, Muita Mídia. Quero ver os perfis de Instagram disponíveis no catálogo.',
)

export function absoluteUrl(path: string) {
  if (!path || path === '/') return SITE_URL
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}
